import api from '@/services/Api'

// ----------------------------- o

const namespaced = true;

// ----------------------------- o

const state = {
    errors: {},
    loading: false,
    data: [],
    places: []
};

// ----------------------------- o

const getters = {

};

// ----------------------------- o

const actions = {
    'USER_FACILITIES_REQUEST': ({commit, dispatch}, user) => {
        return new Promise((resolve, reject) => {
            commit('USER_FACILITIES_REQUEST');
            let url = 'users/facilities?per_page=100';
            api({url: url, method: 'GET'})
                .then(resp => {
                    commit('USER_FACILITIES_REQUEST_SUCCESS', resp.data.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('USER_FACILITIES_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'USER_FACILITIES_PLACES_REQUEST': ({commit, dispatch}, slug) => {
        return new Promise((resolve, reject) => {
            commit('USER_FACILITIES_REQUEST');
            let url = 'users/facilities/'+ slug +'/places';
            api({url: url, method: 'GET'})
                .then(resp => {
                    commit('USER_FACILITIES_PLACES_REQUEST_SUCCESS', resp.data.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('USER_FACILITIES_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'USER_FACILITIES_UPDATE_REQUEST': ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit('USER_FACILITIES_REQUEST');
            let url = payload.facility_slug === 'nowa-firma' ? '/facilities/store' : '/facilities/'+ payload.facility_slug +'/update';
            api({url: url, data: payload.data, method: 'POST'})
                .then(resp => {
                    //commit('USER_FACILITIES_REQUEST_SUCCESS', resp.data.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('USER_FACILITIES_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'USER_FACILITIES_PLACES_UPDATE_REQUEST': ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit('USER_FACILITIES_REQUEST');
            let url = payload.place_slug === 'nowy-lokal' ? '/places/store' : '/places/'+ payload.place_slug +'/update';
            api({url: url, data: payload.data, method: 'POST'})
                .then(resp => {
                    //commit('USER_FACILITIES_REQUEST_SUCCESS', resp.data.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('USER_FACILITIES_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
};

// ----------------------------- o

const mutations = {
    'USER_FACILITIES_REQUEST': (state) => {
        state.errors = {};
        state.loading = true;
    },
    'USER_FACILITIES_REQUEST_SUCCESS': (state, resp) => {
        state.errors = {};
        state.loading = false;
        state.data = resp;
    },
    'USER_FACILITIES_PLACES_REQUEST_SUCCESS': (state, resp) => {
        state.places = resp;
        state.loading = false;
    },
    'USER_FACILITIES_ERROR': (state, resp) => {
        state.errors = resp;
        state.loading = false;
    },
};

// ----------------------------- o

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations,
}
